const APP_BASE_PATH = '/app';

// Relative to the authenticated layout, as the router declares its children.
export const LEADERBOARD_PATHS = {
	INDEX: 'points',
	PNL: 'points/pnl',
	FEES: 'points/fees',
} as const;

export const leaderboardRoute = (path: string): string => `${APP_BASE_PATH}/${path}`;
